import { BASE } from "./index";
import axios from "./http";

const insurance = {
    deductinsurance: (params) => axios.post(`${BASE.PRO1}/logistics/is/deduct/insurance`, params),
    deductinsuranceJP: (params) => axios.post(`${BASE.PRO2}/logistics/is/deduct/insurance`, params),
 
};

export default insurance;
